import { storageConstants } from '../../common/constants/storageConstants.js'

/*
This function clears all the AIRCACHE entries from localStorage and sessionStorage.
*/
export function clearAirCache() {
  if (typeof Storage !== 'undefined') {
    const keysToDelete = []
    for (let index = 0; index < localStorage.length; index++) {
      if (
        localStorage.key(index).startsWith(storageConstants.AIRCACHE_PREFIX)
      ) {
        keysToDelete.push(localStorage.key(index))
      }
    }
    keysToDelete.forEach(key => {
      localStorage.removeItem(key)
    })
    sessionStorage.clear()
  }
}

/*
This function writes to either session storage or Local storage based on the arguments.
Use the constants SESSION_TYPE and LOCAL_TYPE, declared in storageConstants file
for the type argument.
If the first write fails, it clears up the cache and tries again.
So make sure to try catch this function call, because second attempt to write may
fail too, due to reasons other than storage space.
*/
export function writeToStorage(type, key, value) {
  if (
    typeof Storage !== 'undefined' &&
    type &&
    storageConstants[type] &&
    key &&
    value
  ) {
    try {
      storageConstants[type](key, value)
    } catch (error) {
      clearAirCache()
      storageConstants[type](key, value)
    }
  }
}

/*
This function goes through all the air cache items (Prefixed with AIRCACHE)
in local storage, and checks if the stored value has deleteAfter property.
If it does has a deleteAfter property and it is expired, then delete it from storage
*/
export function removeExpiredCache() {
  if (typeof Storage !== 'undefined') {
    const keysToDelete = []
    for (let index = 0; index < localStorage.length; index++) {
      const currentKey = localStorage.key(index)
      if (currentKey.startsWith(storageConstants.AIRCACHE_PREFIX)) {
        try {
          const cachedItem = JSON.parse(localStorage.getItem(currentKey))
          if (cachedItem.deleteAfter) {
            const expiryDate = new Date(cachedItem.deleteAfter).getTime()
            const todaysDate = new Date().getTime()
            if (todaysDate - expiryDate >= 0) {
              keysToDelete.push(localStorage.key(index))
            }
          }
        } catch (err) {
          continue
        }
      }
    }
    keysToDelete.forEach(key => {
      localStorage.removeItem(key)
    })
  }
}
